import React from "react";
import "./LeftBarMenu.css";
import LeftBarMenuItem from "./LeftBarMenuItem";
import ButtonRed from "../ButtonRed";
import { useNavigate } from 'react-router-dom';

function LeftBarMenu() {
  const [isOpened, setIsOpened] = React.useState(false);

  const toggleMenu = () => {
    setIsOpened(!isOpened);
  };
  const navigate = useNavigate();
  return (
    <div className={`left-bar-menu ${isOpened ? "opened" : "closed"}`}>
      <div className='logo'>
        {isOpened && (
          <div className='button-position'>
            <ButtonRed labelText='Play' onClick={() => {
              navigate('/game');
            }}/>
          </div>
        )}
      </div>

      <div className='menu-items'>
        <div className='menu-toggle-button' onClick={toggleMenu}></div>
        <LeftBarMenuItem
          textLabel='Guide'
          isSpecial={true}
          iconUrl='/icon/guide_icon.png'
          isOpened={isOpened}
        />
        <LeftBarMenuItem
          textLabel='Leaderboards'
          iconUrl='/icon/leaderboard_icon.png'
          isOpened={isOpened}
        />
        <LeftBarMenuItem
          textLabel='Welcome bonus'
          iconUrl='/icon/bonus_icon.png'
          isOpened={isOpened}
        />
        <LeftBarMenuItem
          textLabel='Slots'
          iconUrl='/icon/slots_icon.png'
          isOpened={isOpened}
        />
        <LeftBarMenuItem
          textLabel='My Account'
          iconUrl='/icon/account_icon.png'
          isOpened={isOpened}
        />
        <LeftBarMenuItem
          textLabel='My Bonuses'
          iconUrl='/icon/my_bonus_icon.png'
          isOpened={isOpened}
        />
        <LeftBarMenuItem
          textLabel='Support chat'
          iconUrl='/icon/support_icon.png'
          isOpened={isOpened}
        />
      </div>
    </div>
  );
}
export default LeftBarMenu;
